// Weighted A* (ε-A*): f(n) = g(n) + ε·h(n)
// With ε=1 this is standard A*; larger ε trades path optimality for speed.
// At ε=2.5 the found path is at most 2.5× longer than optimal, but
// the explored frontier is dramatically smaller — clearly visible in the animation.
import { WEIGHT_COST } from './constants';
import { getUnvisitedNeighbors, heuristic, MinHeap } from './utils';

const EPSILON = 2.5;

export function weightedAStar(grid, startNode, finishNode) {
    const visitedNodesInOrder = [];
    startNode.gCost = 0;
    startNode.distance = EPSILON * heuristic(startNode, finishNode);

    const heap = new MinHeap();
    heap.insert(startNode);

    while (heap.size > 0) {
        const closestNode = heap.extractMin();

        if (closestNode.isWall) continue;
        if (closestNode.isVisited) continue; // stale heap entry — skip
        if (closestNode.distance === Infinity) return visitedNodesInOrder;

        closestNode.isVisited = true;
        visitedNodesInOrder.push(closestNode);

        if (closestNode === finishNode) return visitedNodesInOrder;

        for (const neighbor of getUnvisitedNeighbors(closestNode, grid)) {
            const tentativeG = closestNode.gCost + (neighbor.isWeight ? WEIGHT_COST : 1);
            if (tentativeG < neighbor.gCost) {
                neighbor.gCost = tentativeG;
                neighbor.distance = tentativeG + EPSILON * heuristic(neighbor, finishNode);
                neighbor.previousNode = closestNode;
                heap.insert(neighbor);
            }
        }
    }

    return visitedNodesInOrder;
}
